import createReducer from './createReducer'

export default createReducer(
  { isLoading: false, currentLoads: 0 },
  {
    LOADING: (state) => ({ isLoading: true, currentLoads: state.currentLoads + 1 }),
    LOADING_FINISHED: (state) => ({ isLoading: state.currentLoads > 1, currentLoads: state.currentLoads - 1 }),
  }
)
